var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35649 1.90354C4.28797 1.93192 4.2294 1.97999 4.1882 2.04166C4.14699 2.10333 4.125 2.17583 4.125 2.25L4.125 9.75C4.125 9.82417 4.14699 9.89667 4.1882 9.95834C4.22941 10.02 4.28797 10.0681 4.3565 10.0965C4.42502 10.1248 4.50042 10.1323 4.57317 10.1178C4.64591 10.1033 4.71273 10.0676 4.76517 10.0152L8.51516 6.26516C8.54998 6.23034 8.57761 6.189 8.59645 6.1435C8.6153 6.09801 8.625 6.04924 8.625 6C8.625 5.95075 8.6153 5.90199 8.59645 5.85649C8.57761 5.811 8.54998 5.76966 8.51516 5.73484L4.76517 1.98484C4.71273 1.93239 4.64591 1.89667 4.57316 1.8822C4.50042 1.86773 4.42502 1.87516 4.35649 1.90354Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpand);
export default __webpack_public_path__ + "static/media/icon_expand.bdaa221853d95a14b91fafc4e862fb82.svg";
export { ForwardRef as ReactComponent };